import { BlockText, Separator, SideBox } from "@nju/ui";
import { formatPrice } from "@nju/utils";
import { SidebarPackageGbOfferBenefits } from "../SidebarPackageGb";

interface ISidebarPackageGbPackageOfferProps {
  productOfferPrice: number;
  anniversaryDate: string;
  productOfferGrantValue: string;
  testId?: string;
}

export function SidebarPackageGbPackageOffer({
  productOfferPrice,
  anniversaryDate,
  productOfferGrantValue,
  testId,
}: ISidebarPackageGbPackageOfferProps) {
  return (
    <SideBox isExpandable={false} testId={testId} title="pakiet 9 GB">
      <BlockText className="my-4" size="keySM" weight="bold">
        {productOfferPrice && formatPrice(productOfferPrice)}
        <span className="text-size-16 font-normal"> zł</span>
      </BlockText>
      <Separator size="s" thickness="medium" tone="accent" />
      <SidebarPackageGbOfferBenefits
        anniversaryDate={anniversaryDate}
        productOfferGrantValue={productOfferGrantValue}
        productOfferPrice={productOfferPrice}
      />
    </SideBox>
  );
}
